import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const DepartmentsFeature: FeatureMetadata = {
  id: "departments",
  moduleName: "humanResources",

  navigation: {
    label: "Departments",
    path: "/departments",
    icon: BuildingOffice2Icon,
    order: 0,
  },

  route: {
    path: "/departments",
    element: lazy(() => import("./pages/Departments")),
  },

  permissions: {
    view: "HumanResource.Departments.view",
    create: "HumanResource.Departments.create",
    edit: "HumanResource.Departments.edit",
    delete: "HumanResource.Departments.delete",
  },

  readiness: "live",
};
